import { Component, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { OnDemandDriverModel } from '../../on-demand-drivers.model';
import { EventEmitter } from '@angular/common/src/facade/async';
import { OnDemandDriversService } from '../../on-demand-drivers.service';
import { T2LoadingService } from '../../../../trip2-theme/components/t2-loading/t2-loading.service';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';

@Component({
  selector: 'app-on-demand-drivers-bank-info',
  templateUrl: './bank-info.component.html',
  styleUrls: ['./bank-info.component.scss']
})
export class BankInfoComponent implements OnInit, OnChanges {

  private data: OnDemandDriverModel = new OnDemandDriverModel();
  private banks: any;

  @Input() selected: number;
  @Output() notify: EventEmitter < boolean > = new EventEmitter < boolean > ();
  @Output() cancel: EventEmitter < boolean > = new EventEmitter < boolean > ();

  constructor(
    protected service: OnDemandDriversService,
    protected _loading: T2LoadingService,
    private sweetAlertHelper: SweetAlertHelper
  ) {
    this.getAllBanks();
  }

  ngOnInit() {
    this.loadBankInfoForSelectedDriver();
  }

  ngOnChanges(changes: SimpleChanges): void {
    const selectedChange = changes['selected'];

    if (
      selectedChange &&
      !selectedChange.isFirstChange() &&
      selectedChange.currentValue &&
      selectedChange.currentValue !== selectedChange.previousValue
    ) {
      this.loadBankInfoForSelectedDriver();
    }
  }

  private loadBankInfoForSelectedDriver(): void {
    this.data = new OnDemandDriverModel();
    if (this.selected !== 0) {
      this.service
      .getDriverByID(this.selected)
      .subscribe(
        data => this.setData(data)
      );
    }
  }

  /**
   * @name getAllBanks
   * @description
   */
  public getAllBanks() {
    this.service
      .getBanks()
      .subscribe(
        data => this.banks = data ,
        (error) => {
          this.sweetAlertHelper.captureException(error);
        }
      );
  }

  /**
   * @name setData
   * @description
   * @param data
   */
  setData(data) {
    delete data.bank;
    this.data = data;
  }

  /**
   * @name sendNotify
   * @description
   * @param data
   */
  sendNotify(data: any) {
    this.notify.emit(data);
  }

  /**
   * @name saveAction
   * @description
   */
  saveAction() {
    this._loading.show();
    if (this.selected === 0) {
      this.service
      .postData(this.data)
      .finally(() => this._loading.hiden())
      .subscribe(
        res => this.sendNotify(res)
      );
    } else {
      this.service
      .putData(this.data)
      .finally(() => this._loading.hiden())
      .subscribe(
        res => this.sendNotify(res)
      );
    }
  }

  /**
   * @name cancelCreateEdit
   * @description
   */
  cancelCreateEdit() {
    this.cancel.emit(true);
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/on-demand-drivers/components/bank-info/bank-info.component.ts